import { render, staticRenderFns } from "./shareSet.vue?vue&type=template&id=936314ec&scoped=true&"
import script from "./shareSet.vue?vue&type=script&lang=js&"
export * from "./shareSet.vue?vue&type=script&lang=js&"
import style0 from "./shareSet.vue?vue&type=style&index=0&id=936314ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936314ec",
  null
  
)

export default component.exports